<template>
  <div
    class="d-flex flex-column align-content-start justify-content-center h-100 pt-5 roster"
  >
    <div v-if="inline" class="row flex-grow-0 flex-shrink-0">
      <div
        class="d-flex col-12 justify-content-start align-content-center py-2"
      >
        <Button
          :label="$t('_web_tournament_back', 'Back')"
          class="btn-accent-border"
          @click="close"
        />
        <div class="mx-3"></div>
        <Button
          :disabled="!hasCaptain || isLoading"
          :label="$t('_web_tournament-create-roster-create', 'Create Roster')"
          class="btn-primary roster-action"
          @click="saveSquad"
        />
      </div>
    </div>
    <div v-if="!inline" class="row flex-grow-0 flex-shrink-0 roster-header">
      <BackBtn
        hide-label
        class="back-button-create-roster"
        @click="goToTournament(currentTournament.id)"
      />
      <div
        class="d-flex w-100 px-5 justify-content-between my-3 create-roster-top"
      >
        <div class="d-flex flex-column create-roster-heading">
          <span class="create-roster-title"
            >Select your roster and choose substitites.</span
          >
          <span class="create-roster-subtitle"
            >{{
              $t(
                '_web_tournament_roster_sub',
                'You can update your roster up until the end of the registration period.'
              )
            }}
          </span>
        </div>
        <Button
          :disabled="!hasCaptain || isLoading"
          :label="$t('_web_tournament_finish_reg', 'Finish Registration')"
          class="btn-primary roster-action"
          @click.prevent.stop="saveSquad"
        />
      </div>
    </div>
    <div class="grid-wrapper">
      <div class="col roster-column">
        <div class="roster-wrapper">
          <div class="mb-3">
            <div class="d-flex justify-content-between pb-4">
              <span class="roster-title">{{
                $t('_web_tournament_roster', 'Roster')
              }}</span>
              <span class="roster-counter">
                {{ membersRoster.length + '/' + squadSize + ' Players' }}
              </span>
            </div>
            <span class="roster-description">{{
              $t(
                '_web_tournament_create_roster_description_new',
                `
              Add at least {squadSize} players to complete your roster.`,
                {
                  squadSize,
                }
              )
            }}</span>
          </div>
          <HeraDummyList
            v-if="isLoading"
            icon-name="dummy/matches"
            :size="210"
            position="center"
            class="flex-grow-1"
          >
            {{
              $t(
                '_web_tournament-create-roster-loading-size',
                'Fetching your current roster...'
              )
            }}
          </HeraDummyList>
          <template v-else>
            <div
              v-for="(member, index) in membersRoster"
              :key="`member-roster-${member.login}`"
              class="d-flex justify-content-between align-items-center cursor-hand rounded w-100"
            >
              <ListItemAccount
                :key="member.login"
                :avatar-props="generateAvatarProps(member)"
                v-bind="{
                  type: member.type,
                  avatar: member.avatar,
                  name: $filters.displayName(member),
                  accountId: member.login,
                  size: 48,
                  approved: member.approved || member.verified,
                  role: !index ? 'Captain' : '',
                }"
                class="w-100 mt-2 roster-item"
              >
              </ListItemAccount>
              <div
                width="36"
                class="memberactionicon"
                @click.stop="removeMemberFromRoster(member, index)"
              >
                <img alt="removeMember" src="@/assets/images/icons/right.svg" />
              </div>
            </div>

            <div
              v-for="index in membersPlaceholderSize"
              :key="`player-placeholder-${index}`"
              class="create-roster-placeholder"
            >
              <ListItemEmptyPlaceholder
                :text="
                  $t(
                    '_web_tournament-create-roster-participant-placeholder',
                    'Add player from list'
                  )
                "
                :height="20"
                class=""
              />
            </div>
          </template>
        </div>
        <div v-if="benchSize" class="substitutes-wrapper">
          <div class="mb-3">
            <div class="d-flex justify-content-between pb-4">
              <span class="roster-title">
                {{ $t('_web_tournament_substitutes', 'Substitiutes') }}</span
              >
              <span class="roster-counter">
                {{ membersBench.length + '/' + benchSize + ' Players' }}
              </span>
            </div>
            <span class="roster-description">{{
              $t(
                '_web_tournament_subsitutes_description_new',
                `
              Add up to {benchSize} subs or skip this step.`,
                {
                  benchSize,
                }
              )
            }}</span>
          </div>
          <HeraDummyList
            v-if="isLoading"
            icon-name="dummy/matches"
            :size="210"
            position="center"
            class="flex-grow-1"
          >
            {{
              $t(
                '_web_tournament-create-roster-loading-size',
                'Fetching your current roster...'
              )
            }}
          </HeraDummyList>
          <template v-else>
            <div
              v-for="(member, index) in membersBench"
              :key="`member-bench-${member.login}`"
              class="d-flex justify-content-between align-items-center roster-item"
            >
              <ListItemAccount
                :avatar-props="generateAvatarProps(member)"
                v-bind="{
                  type: member.type,
                  avatar: member.avatar,
                  name: $filters.displayName(member),
                  accountId: member.login,
                  size: 48,
                  approved: member.approved || member.verified,
                }"
                class="d-flex align-items-center w-100 mt-2 roster-item"
              >
              </ListItemAccount>
              <div
                width="36"
                class="memberactionicon"
                @click.stop="removeMemberFromBench(member, index)"
              >
                <img alt="removeMember" src="@/assets/images/icons/right.svg" />
              </div>
            </div>

            <div
              v-for="index in benchPlaceholderSize"
              :key="`player-placeholder-${index}`"
              class="create-roster-placeholder"
            >
              <ListItemEmptyPlaceholder
                :text="
                  $t(
                    '_web_tournament-create-roster-participant-placeholder',
                    'Add player from list'
                  )
                "
                class=""
              />
            </div>
          </template>
        </div>
      </div>
      <div class="col team-column">
        <div class="member-wrapper">
          <div class="d-flex justify-content-between">
            <span class="roster-title"
              >{{ $t(`_web_tournament-create-roster-team`, `Team`) }}
            </span>
          </div>
          <div v-if="availableMembers.length" class="roster_list-wrapper mt-5">
            <div
              v-for="user in availableMembers"
              :key="`user-${user.login}`"
              class="d-flex flex-row align-items-center w-100 justify-content-between"
            >
              <ListItemAccount
                :avatar-props="generateAvatarProps(user)"
                v-bind="{
                  type: user.type,
                  size: 48,
                  avatar: user.avatar,
                  name: $filters.displayName(user),
                  accountId: user.login,
                  approved: user.approved || user.verified,
                  role: user.team_role,
                }"
                class="d-flex align-items-center justify-content-between w-100 player-item"
                :class="{
                  disabled: isMemberBlocked(user.login),
                }"
              >
              </ListItemAccount>
              <div>
                <span v-if="isMemberBlocked(user.login)">
                  {{
                    $t(
                      '_web_tournament-create-roster-team-member-blocked',
                      'Registered with other team'
                    )
                  }}
                </span>
                <div
                  v-else
                  class="memberactionicon"
                  :disabled="user.added || isRosterComplete"
                  @click.stop="addMember(user)"
                >
                  <img alt="addMember" src="@/assets/images/icons/left.svg" />
                </div>
              </div>
            </div>
          </div>
          <HeraDummyList
            v-else-if="isLoading"
            icon-name="dummy/clans"
            :size="210"
            position="center"
            class="flex-grow-1"
          >
            {{
              $t(
                '_web_tournament-create-roster-form-loading-member-list',
                'Fetching your clan members...'
              )
            }}
          </HeraDummyList>
          <HeraDummyList
            v-else
            icon-name="dummy/members"
            :size="210"
            position="center"
            class="flex-grow-1"
          >
            {{
              $t(
                '_web_tournament-create-roster-form-dummy-member-list',
                'No more available team members'
              )
            }}
          </HeraDummyList>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListItemAccount from '@/components/common/ListItemAccount';
import ListItemEmptyPlaceholder from '@/components/common/ListItemEmptyPlaceholder';
import Button from '@/components/atoms/HeraFormBtn';
import isLoadingMixin from '@/mixins/isLoading';
import HeraDummyList from '@/components/common/HeraDummyList';
import BackBtn from '@/components/common/GoBackBtn.vue';
import { emptyArray, emptyObject } from '@/utils/factories';
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import { translate } from '@/mixins/translate';
import joinAction from '@/views/tournaments/mixins/joinTournamentAction';

const TEAM_LIST_ROSTER = 'roster';
const TEAM_LIST_BENCH = 'bench';

export default {
  name: 'TournamentRegistrationCreateRoster',
  components: {
    ListItemAccount,
    ListItemEmptyPlaceholder,
    Button,
    HeraDummyList,
    BackBtn,
  },
  mixins: [
    isLoadingMixin,
    translate('_web_tournament-create-roster'),
    joinAction,
  ],
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TEAM_LIST_ROSTER,
      TEAM_LIST_BENCH,
      activeTab: TEAM_LIST_ROSTER,
      membersRoster: [],
      membersBench: emptyArray(),
      members: emptyArray(),
      selectedMemberLogin: '',
      membersFormData: emptyObject(),
      blockedMembers: emptyArray(),
      clanID: '',
      allClans: emptyArray(),
    };
  },

  computed: {
    ...mapGetters([
      'registrationData',
      'currentTournament',
      'isAuthorized',
      'currentTournamentStages',
    ]),
    ...mapState('my', ['account', 'accountId']),

    availableMembers() {
      const uniqueMembers = this.members.reduce((result, member) => {
        const isMemberInRoster = this.membersRoster.some(
          rosterMember => rosterMember.login === member.login
        );
        const isMemberInBench = this.membersBench.some(
          benchMember => benchMember.login === member.login
        );

        if (!isMemberInRoster && !isMemberInBench) {
          result.push(member);
        }

        return result;
      }, []);
      return uniqueMembers;
    },

    maxPlayers() {
      return this.currentTournament.max_players;
    },
    squadSize() {
      return this.currentTournament.squad_size;
    },
    benchSize() {
      const benchSize = this.maxPlayers - this.squadSize;
      return Math.max(0, benchSize);
    },
    activeList() {
      switch (this.activeTab) {
        case TEAM_LIST_BENCH:
          return this.membersBench;
        case TEAM_LIST_ROSTER:
        default:
          return this.membersRoster;
      }
    },

    // membersAdded() {
    //   return {
    //     [TEAM_LIST_ROSTER]: {
    //       list: this.membersRoster,
    //       max: this.squadSize,
    //     },
    //     [TEAM_LIST_BENCH]: {
    //       list: this.membersBench,
    //       max: this.benchSize,
    //     },
    //   };
    // },
    membersPlaceholderSize() {
      return this.squadSize - this.membersRoster.length;
    },
    benchPlaceholderSize() {
      return this.benchSize - this.membersBench.length;
    },
    isRosterComplete() {
      return this.membersRoster.length === this.squadSize;
    },
    hasCaptain() {
      return this.membersRoster.length > 0;
    },
  },
  watch: {
    members() {
      if (
        !this.membersRoster.length &&
        this.members.length &&
        this.$route.params.action !== 'edit'
      ) {
        this.addMember(
          this.members.find(member => {
            return member.login === this.account.login;
          })
        );
      }
    },
  },
  created() {
    this.setLoading();
    this.initializeData();
    this.test();
  },

  updated() {
    // this.fetchData();
  },
  methods: {
    ...mapMutations(['setRegistrationData']),
    ...mapActions([
      'setTournamentSquadParticipants',
      'validateJoinTournament',
      'getTournamentSquadParticipants',
      'getProfiles',
      'fetchClanMembers',
      'errorNotify',
      'getTournament',
      'getCompetitionPlayersStatus',
    ]),
    test() {
      this.getCompetitionPlayersStatus({
        id: this.$route.params.tournamentID,
      }).then(res => (this.allClans = res));
    },
    async initializeData() {
      try {
        await this.getClanID(); // Wait for getClanID to complete
        this.getTournament(this.$route.params.tournamentID);
        const blockedMembers = await this.validateJoinTournament({
          tournamentId:
            this.$route.params.tournamentID || this.$route.params.accountId,
          teamId: this.$route.params.clanID || this.clanID,
        });
        this.blockedMembers = blockedMembers;
        await this.fetchData();
        const roster = await this.getTournamentSquadParticipants();
        this.updateSquadList(roster);
      } catch (error) {
        console.error('Error:', error);
        this.errorNotify(error);
      } finally {
        this.unsetLoading();
      }
    },
    updateSquadList(squad) {
      squad.forEach(el => {
        this.addMember(el);
        this.updateMember(el.login, 'added', true);
      });
    },
    getClanID() {
      return new Promise(resolve => {
        // Simulate an asynchronous operation to fetch the clan ID
        setTimeout(() => {
          const clanID =
            this.$route.params.clanID || this.currentTournament.clan_id;
          this.clanID = clanID;
          resolve();
        }, 1000); // Adjust the timeout as needed
      });
    },
    updateMember(login, prop, value) {
      const index = this.members.findIndex(member => member.login === login);
      if (index > -1) {
        this.$set(this.members[index], prop, value);
      }
    },
    isMemberBlocked(login) {
      return this.blockedMembers.includes(login);
    },
    fetchData() {
      if (!this.clanID) {
        // todo - need validate beforeRouterEnter kinda done but shold take a good approach later on
        return Promise.reject(
          this.$t(
            '_web_tournament-create-roster-no-clan-id',
            'Participant must be a clan member'
          )
        );
      }

      this.setLoading();

      return this.fetchClanMembers({
        accountId: this.clanID,
        params: { page_size: 20, page_number: 0 },
      })
        .then(response => {
          const logins = emptyArray();

          this.members = response.items.map(el => {
            logins.push(el.login);
            el.selected = false;
            el.added = false;
            return el;
          });

          return logins;
        })
        .then(this.getProfiles)
        .then(({ items }) => {
          this.members = this.$lodash.merge(this.members, items);
          return {
            items: this.members,
          };
        })
        .catch(this.errorNotify)
        .finally(this.unsetLoading);
    },

    generateAvatarProps({ type, avatar: imgUrl }) {
      return {
        size: 50,
        type,
        imgUrl,
      };
    },
    // checkSelectedUser(index = 0, list) {
    //   if (list.length) {
    //     this.selectUserForm(list[index]);
    //   } else {
    //     this.selectedMemberLogin = '';
    //   }
    // },
    addMember(member) {
      if (this.membersRoster.length >= this.squadSize) {
        if (
          this.membersBench.length + this.membersRoster.length !==
          this.maxPlayers
        ) {
          this.membersBench.push(member);
          member.added = true;
        }
      } else {
        member.added = true;
        this.membersRoster.push(member);
        window.dataLayer.push({
          event: 'tournament join',
          userID: member.display_name,
          from: this.$route.path,
          tournamentId: this.currentTournament.id,
          gameName: this.currentTournament.game,
          squadSize: this.currentTournament.squad_size,
          tournamentName: this.currentTournament.title,
          tournamentFormat: this.currentTournamentStages[0].block_configuration
            .type,
          tournamentCountry: this.currentTournament.country,
          tournamentPool: this.currentTournament.prize.prize_pool,
          regForm: this.currentTournament.requires_registration_form,
          tournamentPrivate:
            this.currentTournament.registration_type === 'closed'
              ? 'true'
              : 'false',
          tournamentOrganizer: this.currentTournament.event_organizer_name,
        });
      }

      // this.checkSelectedUser(this.membersRoster.length - 1);
    },
    removeMemberFromRoster(member, index) {
      this.updateMember(member.login, 'added', false);
      window.dataLayer.push({
        event: 'tournament revoke',
        userID: member.display_name,
        tournamentId: this.currentTournament.id,
        from: this.$route.path,
        gameId: this.currentTournament.game,
        gameName: this.currentTournament.game,
        tournamentName: this.currentTournament.title,
        squadSize: this.currentTournament.squad_size,
        tournamentFormat: this.currentTournamentStages[0].block_configuration
          .type,
        tournamentCountry: this.currentTournament.country,
        tournamentPool: this.currentTournament.prize.prize_pool,
        regForm: this.currentTournament.requires_registration_form,
        tournamentPrivate:
          this.currentTournament.registration_type === 'closed'
            ? 'true'
            : 'false',
        tournamentOrganizer: this.currentTournament.event_organizer_name,
      });
      // this.updateMember(member.login, 'selected', false);
      if (this.membersRoster.length > 0) {
        this.membersRoster.splice(index, 1);
        member.added = false;
      }
    },
    removeMemberFromBench(member, index) {
      this.updateMember(member.login, 'added', false);
      this.membersBench.splice(index, 1);
      member.added = false;
    },
    // selectUserForm(member = {}) {
    //   this.membersRoster.forEach(el => (el.selected = el === member));
    //   this.selectedMemberLogin = member.login;
    // },
    updateSquadParticipants() {
      const squad = [
        ...this.membersRoster.map(user => user.login),
        ...this.membersBench.map(user => user.login),
      ];
      return this.setTournamentSquadParticipants({
        clanId: this.clanID,
        squad,
      });
    },
    updateSquadParticipantsNew() {
      const players = [
        ...this.membersRoster.map(user => ({ user_id: user.login })),
        ...this.membersBench.map(user => ({ user_id: user.login })),
      ];
      this.setRegistrationData({
        ...this.registrationData,
        players,
      });
      return this.regularJoinProcedure(
        this.$route.params.tournamentID,
        this.clanID
      );
    },

    checkPaymentStatusPending() {
      const requestedClans = this.allClans.filter(
        clan => clan.registration_status === 'payment_pending'
      );
      const requestedClanIds = requestedClans.map(clan => clan.clan.id);
      return requestedClanIds.includes(this.clanID);
    },
    saveSquad() {
      // const players = Object.values(this.membersFormData);

      // this.setRegistrationData({
      //   ...this.registrationData,
      //   players,
      // });
      const requestedClans = this.allClans.filter(
        clan => clan.registration_status === 'requested'
      );
      const requestedClanIds = requestedClans.map(clan => clan.clan.id);
      if (
        requestedClanIds.includes(this.clanID) ||
        this.checkPaymentStatusPending()
      ) {
        return this.updateSquadParticipants()
          .then(() => {
            if (this.inline) {
              this.$emit('close', true);
            } else {
              this.goToTournament(this.currentTournament.id);
            }
          })
          .catch(this.errorNotify)
          .finally(
            window.dataLayer.push({
              event: 'finish team tournament',
              userID: this.account._id,
              from: this.$route.path,
              tournamentId: this.currentTournament.id,
              gameName: this.currentTournament.game,
              squadSize: this.currentTournament.squad_size,
              tournamentName: this.currentTournament.title,
              tournamentFormat: this.currentTournamentStages[0]
                .block_configuration.type,
              tournamentCountry: this.currentTournament.country,
              tournamentPool: this.currentTournament.prize.prize_pool,
              regForm: this.currentTournament.requires_registration_form,
              tournamentPrivate:
                this.currentTournament.registration_type === 'closed'
                  ? 'true'
                  : 'false',
              tournamentOrganizer: this.currentTournament.event_organizer_name,
            })
          );
      } else {
        return this.updateSquadParticipantsNew();
      }
    },
    close() {
      this.$emit('close', false);
    },
    goToTournament(accountId) {
      this.$router.push({
        path: `/tournament/${accountId}`,
        params: {
          accountId,
          accountType: this.$routerNames.TOURNAMENT,
        },
      });
    },
  },
};
</script>
<style lang="scss">
.back-button-create-roster {
  margin-bottom: 2rem;

  .playhera-icon svg {
    height: 40px;
    width: 40px;
  }
}
</style>
<style lang="scss" scoped>
.memberactionicon {
  cursor: pointer;

  .app-rtl & {
    transform: scaleX(-1);
  }

  @media (max-width: 1080px) {
    transform: rotate(90deg);
  }
}

.create-roster-top {
  @media (max-width: 680px) {
    gap: 2rem 1rem;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    justify-content: start;
    gap: 2rem;
  }
}

.create-roster-placeholder {
  height: 4rem;
  max-width: 16rem !important;
}

.grid-wrapper {
  display: flex;
  justify-content: center;
  gap: 2rem;

  @media (max-width: 1080px) {
    flex-direction: column;
  }

  @media (max-width: 600px) {
    justify-content: start;
    padding: 0;
  }
}

.roster-header {
  max-width: 1170px;
  width: 100%;
  margin: auto;
}

.team-column {
  display: flex;
  flex-direction: column;
  max-width: 560px;
  gap: 2rem;
}

.create-roster-heading {
  gap: 0.875rem;
  max-width: 50vw;

  @media (max-width: 600px) {
    max-width: 100%;
  }
}

.create-roster-title {
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: $new-fg-neutral-faded;
}

.create-roster-subtitle {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: $new-fg-neutral-faded;
  overflow-wrap: break-word;
}

.roster-wrapper,
.substitutes-wrapper,
.member-wrapper {
  background-color: $new-bg-base;
  padding: 2.5rem 4rem;
  border-radius: 5px;
  gap: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 325px;

  @media (max-width: 600px) {
    padding: 1rem;
    min-width: 250px;
  }
}

.roster-title {
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
}

.roster-counter {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}

.roster-description {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: $new-fg-neutral-faded;
}

.roster {
  gap: 3rem;

  &-action {
    height: 3rem;
    padding: 1rem;
    border-radius: 0.5rem;
    width: 10rem;

    > span {
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }

    &:not(:last-child) {
      @include auto-rtl(margin-right, 1.5rem);
    }
  }

  &-column {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    max-width: 560px;

    .horizontal-tabs-wrapper__item {
      font-size: 1.5rem;
      font-family: $ph-font-family-secondary;
      text-align: left !important;
      border: 0;
      padding: 0 0 0.5rem 0px !important;
    }

    // &:not(:last-child) {
    //   border-right: 2px dashed $ph-secondary-text;
    // }
  }

  &-member-transition {
    &-enter-active,
    &-leave-active {
      transition: all 0.35s ease-in-out;
    }

    &-enter,
    &-leave-to {
      transform: translateY(-20px);
      opacity: 0;
    }
  }

  &-button-remove {
    border: 1px solid $ph-error;
  }

  &-item {
    border: none;
    height: 4rem;
    max-width: 15rem !important;
    padding: 0.5rem 0rem;

    @media (max-width: 600px) {
      max-width: 10rem !important;
    }
  }

  .player-item {
    border: none;
    height: 4rem;
    max-width: 15rem !important;
    padding: 0.5rem 0rem;

    @media (max-width: 600px) {
      max-width: 10rem !important;
    }
  }

  &_list-wrapper > div {
    background-color: transparent;
  }

  &_bottom-action-wrapper {
    margin-top: -87px;
    padding: 0 4px;

    button {
      min-width: 160px;
    }
  }
}
</style>
